import { baseColor } from "../..";

const style = {
  color: {
    blue: `border-blue-500`,
    green: `border-green-500`,
    red: `border-red-500`,
    yellow: `border-yellow-500`,
    indigo: `border-indigo-500`,
    white: `border-white`,
  },
};

export const Spiner = () => {
  return (
    <div className="flex z-50 overlay items-center h-full justify-center">
      <div className={`animate-spin h-10 w-10 border-4 ${style.color[baseColor]} rounded-full border-t-transparent`}></div>
    </div>
  );
}

export const ButtonLoading = () => {
    return (
      <div className="flex z-50 overlay items-center h-full justify-center">
        <div className="animate-spin h-5 w-5 border-2 border-white rounded-full border-t-transparent"></div>
      </div>
    );
  }
